'use es6';

import I18n from 'I18n';
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import PatagoniaSidebarHeader from 'ContentEditorUI/components/sidebar/PatagoniaSidebarHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AsyncTreeViewModuleListContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'TreeViewModuleListContainer' */'ContentEditorUI/components/sidebar/list/treeView/TreeViewModuleListContainer'));
const PatagoniaSidebarContentContainer = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PatagoniaSidebarHeader, {
      headerText: I18n.text('patagonia.sidebar.contentsHeader')
    }), /*#__PURE__*/_jsx("div", {
      className: "sidebar-scrollable-tab-panel",
      children: /*#__PURE__*/_jsx(AsyncTreeViewModuleListContainer, {
        allowBodyStyling: true
      })
    })]
  });
};
export default PatagoniaSidebarContentContainer;